<template>
  <auth-layout>
    <div
      class="login"
      align="center"
    >
      <div v-if="email == null">
        <h3>Invalid URL</h3>
        <img
          src="@/assets/logo/locked.png"
          width="100"
          class="mt-40 mb-30"
        />
      </div>
      <div v-else-if="email != null">
        <h3>Verify User</h3>
        <img
          src="@/assets/logo/locked.png"
          width="100"
          class="mt-40 mb-30"
        />
        <p v-if="invalidMessage !== ''">{{ invalidMessage }}</p>
        <validation-observer v-slot="{ invalid }">
          <form
            @submit="resetPassword"
            v-if="invalidMessage === ''"
            align="left"
          >
            <form-input
              label="Email"
              name="email"
              placeholder=""
              v-model="email"
              vid="email"
              rules="required"
              type="text"
              disabled="disabled"
            />
            <form-input
              label="New Password"
              name="new password"
              placeholder="Input New Password"
              v-model="password"
              vid="password"
              rules="required|password"
              type="password"
              :error="errors.password"
            />
            <form-input
              label="Confirm New Password"
              name="new password confirmation"
              placeholder="Input New Password Confirmation"
              v-model="passwordConfirm"
              rules="required|confirmed:password"
              type="password"
              :error="errors.passwordConfirm"
            />
            <Button
              style="margin-top: 20px;"
              color="blue"
              display="block"
              type="submit"
              variant="login"
              :loading="loading"
              :disabled="invalid"
            >
              Verify
            </Button>
          </form>
        </validation-observer>
      </div>
    </div>
  </auth-layout>
</template>

<script>
import sjcl from 'sjcl';

import { ValidationObserver } from 'vee-validate';

import AuthLayout from '@/components/AuthLayout.vue';
import FormInput from '@/components/FormInput.vue';
import Button from '@/components/Button.vue';
import api from '../../libs/api';

export default {
  data() {
    return {
      email: null,
      password: '',
      passwordConfirm: '',
      invalidMessage: '',
      errors: {
        password: '',
        passwordConfirm: '',
      },
      loading: false,
    };
  },
  components: {
    ValidationObserver,
    AuthLayout,
    FormInput,
    Button,
  },
  methods: {
    async getUnits() {
      const { data } = await api.get(this.$route.fullPath,
        { headers: { token: this.$route.params.token } });
      this.email = data.data.email;
    },

    async resetPassword(e) {
      e.preventDefault();

      try {
        this.loading = true;
        this.errors = {
          email: '',
          password: '',
        };

        const out = sjcl.hash.sha256.hash(this.password);
        const hash = sjcl.codec.hex.fromBits(out);

        await api.post(this.$route.fullPath, {
          email: this.email,
          newPassword: hash,
        }, { headers: { token: this.$route.params.token } });

        this.$router.push('/login?from=reset');
      } catch (err) {
        this.loading = false;
        err.response.data.errors.forEach((item) => {
          if (item.reason === 'IncorectPasswordException') {
            this.errors.password = item.message;
          }
        });
      }
    },
  },
  beforeMount() {
    this.getUnits();
  },
};
</script>

<style lang="scss" scoped>
.login {
  width: 300px;
  padding: 20px 0;
}

img.logo {
  height: 70px;
  width: auto;
  display: block;
  margin: 0 auto;
}

h3 {
  font-size: 20px;
  font-weight: 700;
  color: $darkerBlue;
  text-align: center;
}

p {
  text-align: center;

  &::first-letter {
    text-transform: capitalize;
  }
}

a.forgot-password,
a {
  color: $red;
  text-decoration: none;
  font-size: 14px;
  margin-top: -5px;
  font-weight: 500;
  display: block;
  text-align: right;
}
</style>
